import React from 'react'
import { PALETTE } from "@fedsim/constants";

const spacerSizes = {
  DEFAULT: {
    margin: "10px 0",
    borderWidth: "3px"
  },
  xs: {
    margin: "6px 0",
    borderWidth: "2px"
  },
  small: {
    margin: "16px 0",
    borderWidth: "2px"
  },
  large: {
    margin: "40px 0",
    borderWidth: "2px"
  }
}

export const SpacedDivider = ({ size = "DEFAULT", ...props }) => {
  return <hr style={{
    ...spacerSizes[size],
    borderWidth: 1,
    borderColor: PALETTE.DIVIDER,
    borderStyle: 'solid'
  }} {...props} />
}

export default SpacedDivider